module.exports = __webpack_public_path__ + "img/google-icon.938d79e.png";